import React from 'react';
import { Form } from 'react-bootstrap';

export const SkeletonField = ({ height = '38px', className = '' }) => (
  <div 
    className={`skeleton-field ${className}`}
    style={{ 
      height, 
      borderRadius: '4px',
      backgroundColor: 'var(--color-skeleton)',
      animation: 'skeleton-pulse 1.5s ease-in-out infinite'
    }}
  />
);

export const SkeletonSelect = ({ className = '' }) => (
  <Form.Group className={`mb-3 ${className}`}>
    <div 
      className="skeleton-field"
      style={{ 
        height: '20px', 
        width: '150px',
        marginBottom: '8px',
        borderRadius: '4px',
        backgroundColor: 'var(--color-skeleton)',
        animation: 'skeleton-pulse 1.5s ease-in-out infinite'
      }}
    />
    <SkeletonField height="38px" />
  </Form.Group>
);

export const SkeletonTextarea = ({ rows = 3, className = '' }) => (
  <Form.Group className={`mb-3 ${className}`}>
    <div 
      className="skeleton-field"
      style={{ 
        height: '20px', 
        width: '150px',
        marginBottom: '8px',
        borderRadius: '4px',
        backgroundColor: 'var(--color-skeleton)',
        animation: 'skeleton-pulse 1.5s ease-in-out infinite'
      }}
    />
    <SkeletonField height={`${rows * 24}px`} />
  </Form.Group>
);

export const SkeletonForm = ({ fields = 5 }) => (
  <div>
    {Array.from({ length: fields }).map((_, idx) => (
      <SkeletonSelect key={idx} />
    ))}
  </div>
);

